import React from "react";
import { SliceConfig } from "~components";
import * as styles from "./styles.module.scss";

const ColorBlockHeader = ({ data: { title, sliceConfig } }) => (
  <header>
    <SliceConfig config={sliceConfig}>
      <div className={styles.colorBlock}>
        <h1 className="h1">{title}</h1>
      </div>
    </SliceConfig>
  </header>
);

export default ColorBlockHeader;
